import React, { Children, Suspense, lazy } from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'

import AdminLayout from 'app/layout/layout-datta-able/AdminLayout'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { FallbackView } from '../../_metronic/partials'
import { SettingWrapper } from '../pages/setting/SettingWrapper'
import { useLocation } from 'react-router-dom';

export function PrivateRoutes() {
  const location = useLocation();
  const history = useHistory();

  const YtbChannelGeneral = lazy(() => import('../modules/accounts/YtbChannelGeneral'))
  const ProxyPage = lazy(() => import('../modules/proxy/ProxyPage'));
  const AccountDetailPage = lazy(() => import('../modules/accounts/ChannelDetail'));
  const UsersPage = lazy(() => import('../modules/users/UserPage'));
  const PrivatePage = lazy(() => import('../modules/private/PrivatePage'));
  const YoutubeRanking = lazy(() => import('../modules/accounts/YoutubeRanking'));
  const VideoUploaded = lazy(() => import('../modules/accounts/VideoUploaded'));
  const CategoryManagement = lazy(() => import('../modules/accounts/CategoryManagement'));
  const DeadChannel = lazy(() => import('../modules/accounts/DeadChannel'));

  const Props = {
    location: location,
    history: history,
    children: (
      <Suspense fallback={<FallbackView />}>
        <Switch location={location} key={location.pathname}>
          <Route path='/dashboard' component={DashboardWrapper} />
          <Route path='/setting' component={SettingWrapper} />
          <Route path='/accounts/general' component={YtbChannelGeneral} />
          <Route path='/accounts/ranking' component={YoutubeRanking} />
          <Route path='/accounts/videos-upload' component={VideoUploaded} />
          <Route path='/accounts/category-manage' component={CategoryManagement} />
          <Route path='/accounts/dead-channel' component={DeadChannel} />
          <Route path='/proxies' component={ProxyPage} />
          <Route path='/users' component={UsersPage} />
          <Route path='/private' component={PrivatePage} />
          <Route path='/account-detail/:user_id' component={AccountDetailPage} />

          <Redirect from='/auth' to='/dashboard' />
          <Redirect exact from='/' to='/dashboard' />
          <Redirect to='error/404' />
        </Switch>
      </Suspense>
    ) 
  }

  return (
    <AdminLayout {...Props} />
  )
}
